<template lang="pug">
.delete-confirmation-details
  .text-lg.font-medium {{ $t('delete_confirmation', { text: $t('item').toLowerCase() }) }}
    v-card.round-md.pa-4.mt-4(v-if="selectedTreatment.productItem" outlined color="neutral300")
      .text-md.font-semibold {{ selectedTreatment.productItem.name }}
      .text-sm {{ $t('quantity') }} : {{ selectedTreatment.quantity }}
      .text-sm(v-if="selectedTreatment.priceTier && selectedTreatment.priceTier.name") {{ $t('price_tier') }} : {{ selectedTreatment.priceTier.name }}
      .text-sm(v-if="selectedTreatment.rate >= 0") {{ $t('rate') }} : {{ selectedTreatment.rate | displayPrice }}
      template(v-if="selectedTreatment.productItem.medication")
        .text-sm {{ $t('dosage') }} : {{ selectedTreatment.productItem.medication.dosage_value }} {{ selectedTreatment.productItem.medication.dosage_unit }}
        .text-sm {{ $t('duration') }} : {{ selectedTreatment.productItem.medication.duration }}
        .text-sm {{ $t('frequency') }} : {{ selectedTreatment.productItem.medication.frequency }}
        .text-sm {{ $t('instruction') }} : {{ selectedTreatment.productItem.medication.instruction }}
        .text-sm {{ $t('precaution') }} : {{ selectedTreatment.productItem.medication.precaution }}
    .text-md.mt-4 {{ $t('item_delete_confirmation_description_primary', { item: $t('item') }) }}
    .text-md {{ $t('item_delete_confirmation_description_secondary') }}
</template>

<script>
export default {
  props: {
    selectedTreatment: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>